module.exports = __webpack_public_path__ + "assets/browse.23467521.svg";